export default __webpack_public_path__ + "static/media/copy-light.802ae82b.svg";